import Link from 'next/link';
import classNames from 'classnames';
import ReviewCard from './ReviewCard';
import { CompanyReviewsProps } from './types';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const CompanyReviews = ({ reviews, className }: CompanyReviewsProps) => (
  <div className={classNames(className)}>
    <div className="flex flex-col gap-4">
      {reviews.slice(0, 5).map((review) => {
        const { title, stars, text, createdAt } = review;
        const customerName = review.consumer.displayName;

        return (
          <ReviewCard
            key={review.id}
            title={title}
            stars={stars}
            text={text}
            createdAt={createdAt}
            customerName={customerName}
          />
        );
      })}
    </div>
    <Link
      href={`/reviews`}
      className="mt-4 flex h-10 items-center justify-center rounded border border-gray-700 text-xs font-medium transition duration-150 ease-in-out hover:bg-gray-700 hover:text-white focus:outline-none disabled:cursor-not-allowed disabled:opacity-50"
    >
      {t`See All Reviews`}
    </Link>
  </div>
);

export default CompanyReviews;
